module.exports = __webpack_public_path__ + "img/production-default.2bedf0e1.svg";